import React from "react"
import { Fade } from "react-awesome-reveal"

const DownloadIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100"
    height="100"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
    <polyline points="7 10 12 15 17 10" />
    <line x1="12" y1="15" x2="12" y2="3" />
  </svg>
)

export const ReportDownloadItem = ({
  href,
  title,
  thumbnailSrc,
  thumbnailAlt,
  buttonLabel,
  downloadFilename,
}) => {
  return (
    <div className="report-row">
      <Fade triggerOnce>
        <a
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          className="report-thumbnail"
        >
          <img src={thumbnailSrc} alt={thumbnailAlt} />
        </a>
      </Fade>
      <Fade triggerOnce>
        <div className="report-info">
          <h2>{title}</h2>
          <a
            href={href}
            download={downloadFilename}
            className="report-download"
          >
            <DownloadIcon />
            <span>{buttonLabel}</span>
          </a>
        </div>
      </Fade>
    </div>
  )
}

const reportItem = {
  href: "/documents/lid-2026-report.pdf",
  title: "Law in Distress 2026 Report",
  thumbnailSrc: "/images/lid-report-thumbnail.jpg",
  thumbnailAlt: "Law in Distress 2026 Report cover",
  buttonLabel: "Download Report",
  downloadFilename: "LID-Report-2026.pdf",
}

const Report = () => {
  return (
    <div className="report-content">
      <div className="container">
        <ReportDownloadItem {...reportItem} />
      </div>
    </div>
  )
}

export default Report
